import { Typography } from "@packages/ds";
import styled from "styled-components";

import ToggleDefault from "ds/Toggle";

export const ContentWrapper = styled.div<{ $isEmbedded?: boolean }>`
  @media (max-width: 1030px) {
    padding: ${props => (props.$isEmbedded ? "0" : "0 16px")};
  }
`;

export const InnerWrapper = styled.div<{ $isEmbedded?: boolean }>`
  margin-block: 32px;

  @media (max-width: 1030px) {
    max-width: ${props => (props.$isEmbedded ? "unset" : "600px")};
    margin-inline: ${props => (props.$isEmbedded ? "unset" : "auto")};
  }
`;

export const Separator = styled.hr<{
  type: "minor" | "major";
  margin?: string | number;
}>`
  grid-column: 1 / -1;
  background-color: ${({ type }) =>
    type === "minor"
      ? "var(--divider-periwinkle-grey-background-color, var(--periwinkle-grey))"
      : "var(--divider-granite-background-color, var(--granite))"};
  ${({ margin }) => `margin: ${margin ?? 0};`}
`;

export const PanelWrapper = styled.div<{ $isEmbedded?: boolean }>`
  border-radius: 8px;
  padding: ${props => (props.$isEmbedded ? "24px 24px 0 24px" : "24px 32px")};
  background-color: var(--section-snow-background-color, var(--snow));
`;
export const Stack = styled.div<{ space?: number }>`
  display: flex;
  flex-direction: column;
  gap: ${({ space }) => `${space ?? 16}px`};
`;

export const SpacedRow = styled.div<{ space?: number; align?: string }>`
  display: flex;
  gap: ${({ space }) => `${space ?? 8}px`};
  align-items: ${({ align }) => align ?? "center"};
`;

export const BaseBillingTable = styled.div`
  display: grid;
  gap: 12px 24px;
  align-items: center;
`;

export const BillingTitle = styled(Typography.Title)`
  margin-left: 16px;
`;

export const RightText = styled(Typography.BodyText)<{
  $shouldRenderSpaced?: boolean;
}>`
  text-align: right;
  margin-right: ${props => (props.$shouldRenderSpaced ? "33.5px" : "unset")};
`;

export const RowLabel = styled(Typography.BodyText).attrs(() => ({
  size: "medium",
  weight: "bold",
  $color: "ebony"
}))`
  grid-column: 1 / -1;
  display: flex;
  align-items: baseline;
  gap: 16px;

  small {
    font-size: 1em;
    font-weight: 400;
  }
`;

export const RowLabelSub = styled(RowLabel).attrs(() => ({
  size: "medium",
  weight: "semiBold",
  $color: "granite"
}))<{ $isSpacingSmall?: boolean }>`
  margin-top: ${props => (props.$isSpacingSmall ? "8px" : "12px")};
`;

export const ColumnHeading = styled(Typography.BodyText).attrs(() => ({
  size: "extraSmall",
  weight: "semiBold"
}))<{ textAlign?: string; $spacing?: string }>`
  margin-bottom: ${props => (props.$spacing ? props.$spacing : "-12px")};
  ${({ textAlign }) => (textAlign ? `text-align: ${textAlign}` : "")};
`;

export const BodyTextSubtle = styled(Typography.BodyText).attrs(() => ({
  $color: "granite",
  size: "small"
}))``;

export const Estimate = styled.div<{
  variant?: "default" | "dark";
  $isEmbedded?: boolean;
}>`
  margin-inline: ${props => (props.$isEmbedded ? "" : "-16px")};
  padding: 8px 16px;
  border-radius: 8px;
  background-color: ${({ variant }) =>
    variant === "dark"
      ? "var(--section-color-neutral-300-background-color, var(--color-neutral-300))"
      : "var(--section-color-primary-100-background-color, var(--color-primary-100))"};
`;

export const InvoiceTitleWrapper = styled.div`
  display: grid;
  gap: 16px;
  grid-template-columns: max-content auto max-content;
`;

export const InvoiceNextTitle = styled(Typography.Title)`
  margin-bottom: 16px;
`;

export const Toggle = styled(ToggleDefault)`
  width: unset;
`;

export const ToggleWrapper = styled.div`
  display: flex;
  margin-bottom: 16px;
  gap: 4px;
`;

export const DialogWrapper = styled.span<{ justifyContent?: "start" | "end" }>`
  display: flex;
  gap: 4px;
  ${({ justifyContent }) =>
    justifyContent ? `justify-content: ${justifyContent}` : ""};
`;

export const IconWrapper = styled.button`
  padding: 0;
  background-color: transparent;
  border: 1px solid transparent;

  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  mix-blend-mode: normal;
  border-radius: 2px;
  cursor: pointer;

  display: inline-flex;
  justify-content: center;
  align-items: center;
  height: 24px;
  width: 24px;

  transition-duration: 0.25s;
  transition-property: color, background-color, border-color, box-shadow;
`;
